import { axios } from 'shared/services/axios'
import * as authorizationApi from 'Authorization/api/authorization'

const SET_AUTH_ID = 'authorization/SET_AUTH_ID'
const FETCH_ACCESS_AUTHORIZATION_SUCCESS = 'authorization/FETCH_ACCESS_AUTHORIZATION_SUCCESS'
const FETCH_CAMPAIGN_SUCCESS = 'authorization/FETCH_CAMPAIGN_SUCCESS'

export function setAuthId(authId) {
  return function(dispatch) {
    dispatch({
      type: SET_AUTH_ID,
      authId
    })
  }
}

export function fetchCampaign(authId) {
  return function(dispatch) {
    return authorizationApi.fetchCampaign(authId)
      .then(data => {
        dispatch({
          type: FETCH_CAMPAIGN_SUCCESS,
          campaign: data
        })
      })
  }
}

export function fetchAccessAuthorization(authId) {
  return function(dispatch) {
    return authorizationApi.fetchAccessAuthorization(authId)
      .then(data => {
        dispatch({
          type: FETCH_ACCESS_AUTHORIZATION_SUCCESS,
          accessType: data
        })
      })
  }
}

const initialState = {
  accessType: FollozeState.accessAuthorizations
}

export default function authorization(state = initialState, action) {
  switch (action.type) {
    case SET_AUTH_ID:
      return {
        ...state,
        authId: action.authId
      }
    case FETCH_CAMPAIGN_SUCCESS:
      return {
        ...state,
        campaign: action.campaign
      }
    case FETCH_ACCESS_AUTHORIZATION_SUCCESS:
      return {
        ...state,
        accessType: action.accessType
      }
    default:
      return state
  }
}
